import { createFileRoute } from '@tanstack/react-router'

import { companyDepartmentsQueries } from '@/http/api/companyDepartments'
import { UsersDetailsForm } from '@/users/components/UsersDetails/UsersDetailsForm'

export const Route = createFileRoute('/company/_management/users/$userId/')({
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(companyDepartmentsQueries.list())
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { userId } = Route.useParams()

  return <UsersDetailsForm userId={userId} />
}
